import gql from 'graphql-tag'

export const deviceBillingInfo = gql`
  query DeviceBillingInfo($deviceId: ID!) {
    billingInfo(deviceId: $deviceId) {
      firstName
      lastName
      company
      phone
      country
      street
      email
      vat
      invoiceLang
      companyId
      streetNumber
      apartmentNumber
      subscriptionLength
      zipCode
      city
      prices {
        currency
        price
      }
      deviceName
      items {
        title
      }
      paymentsManagedByEledio
      billingInfoManagedByEledio
    }
  }
`
